import { AlertTriangle } from 'lucide-react';

// Shown when the API capped a list (X-Total-Count > items received), so missing
// rows are never mistaken for missing disks.
export const TruncationNotice = ({ shown, total, noun }) =>
    total > shown ? (
        <p role="status" className="flex items-start gap-2 text-sm p-3 rounded-lg border border-tone-alerte-base/30 bg-tone-alerte-base/10 text-tone-alerte">
            <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" aria-hidden="true" />
            <span>
                {shown} {noun} affichés sur {total}. Affinez la recherche ou les filtres pour voir les autres.
            </span>
        </p>
    ) : null;

export const totalFromHeaders = (response) => {
    const total = parseInt(response?.headers?.['x-total-count'], 10);
    return Number.isNaN(total) ? null : total;
};
